import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { prefix } from "./index";
import "./Footer.less";

const Footer: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-agreement`}>
        <Link to={'https://wonder.app/terms-conditions/'}>
          {t('terms')}
        </Link>
        <div className="divider"></div>
        <Link to={'https://wonder.app/privacy-policy/'}>
          {t('privacy')}
        </Link>
      </div>
      <div>© {dayjs().format('YYYY')} Wonder Ventures Ltd.{' '} {t('rights_reserved')}</div>
    </div>
  );
};

export default Footer;

